import { Select } from "antd";
import { SelectProps } from "antd";
import { LanguageContext } from "contexts/LanguageContext";
import React, { useContext, useEffect, useState } from "react";
import { parseCookies, setCookie } from "nookies";
import { getLanguageByDomain } from "services/companiesHeads.service";
import { GlobalOutlined } from "@ant-design/icons";

const languageNames: { [key: string]: string } = {
  en: "English",
  ptBr: "Português (BR)",
  pt: "Português (PT)",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
};

export const SelectLang: React.FC<SelectProps> = () => {
  const { currentLanguage, handleChangeLanguage } = useContext(LanguageContext);
  const [languages, setLanguages] = useState<string[]>(["en"]);

  useEffect(() => {
    const fetchLanguages = async () => {
      const { "auth.type": type } = parseCookies();
      const { preferred_language } = parseCookies();

      if (!type) {
        setLanguages(["en", "de", "es", "fr", "pt", "ptBr"]);

        return;
      }

      if (type === "0" || type === "4" || type === "5") {
        setLanguages(["en", "de", "es", "fr", "pt", "ptBr"]);

        return;
      } else {
        try {
          const response = await getLanguageByDomain();
          // Garante que o inglês sempre esteja presente e seja o primeiro
          const uniqueLanguages = [...new Set([...response.languages, "en"])];
          const sortedLanguages = uniqueLanguages
            .filter((lang) => lang !== "en") // Remove o inglês do array
            .sort() // Ordena as outras línguas
            .concat([]); // Cria um novo array para evitar mutação

          // Coloca o inglês no início
          sortedLanguages.unshift("en");

          setLanguages(sortedLanguages);

          if (sortedLanguages && sortedLanguages.length && preferred_language) {
            if (!sortedLanguages.includes(preferred_language)) {
              setCookie(null, "preferred_language", "en", {
                maxAge: 30 * 24 * 60 * 60,
                path: "/",
              });

              window.location.reload();
            }
          }

          return;
        } catch (error) {
          console.error("Error fetching languages:", error);
        }
      }
    };

    fetchLanguages();
  }, []);

  const handleLanguageChange = (value: string) => {
    handleChangeLanguage(value);
    setCookie(null, "preferred_language", value, {
      maxAge: 30 * 24 * 60 * 60,
      path: "/",
    });
  };

  const getLanguageOptions = () => {
    return languages.map((lang) => (
      <Select.Option key={lang} value={lang}>
        {languageNames[lang] || lang}
      </Select.Option>
    ));
  };

  return (
    <Select
      defaultValue={currentLanguage}
      variant="outlined"
      className="w-40"
      onSelect={handleLanguageChange}
      suffixIcon={<GlobalOutlined />}
    >
      {getLanguageOptions()}
    </Select>
  );
};
